import {
  Component,
  Input,
  OnInit,
  ChangeDetectionStrategy,
} from "@angular/core";

@Component({
  selector: "up-help-button",
  templateUrl: "./help-button.component.html",
  styleUrl: "./help-button.component.css",
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class HelpButtonComponent implements OnInit {
  @Input() isValorUpDomain: boolean = false;

  ngOnInit(): void {}

  openHelpDesk(): void {
    // TODO: Corrigir aqui, será necessário obter a base da URL via variável de ambiente
    if (!this.isValorUpDomain)
      window.open("https://tickets.doneapp.com.br/1/external-login", "_blank");
    else {
      window.open("https://helpdesk.doneapp.com.br/", "_blank");
    }
  }
}
